import { consumablesService } from "Dashboard/scenes/Consumables/services/consumables.service";
import { forwardRef, useEffect, useState } from "react";
import Select from "react-select";
import { categoryDictionary } from "utils/translationDictionary";

interface ICategoryOption {
  label: string;
  value: string;
}

const CategorySelect = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<ICategoryOption[]>([]);
  const [value, setValue] = useState<ICategoryOption | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      const data = await consumablesService.getAllCategoriesForItem();
      const op = data.map((category) => {
        return {
          label: categoryDictionary[category.name],
          value: category.name,
        };
      });
      setOptions(op);
      setIsLoading(false);
    }

    try {
      getData();
    } catch (err) {
      console.log(err);
    }
  }, []);

  const handleChange = (newValue: any, actionMeta: any) => {
    setValue(newValue);
    props.onChange(newValue ? newValue.value : null);
  };

  useEffect(() => {
    const values = options.filter((o) => o.value === props.value);
    if (values[0]) {
      setValue(values[0]);
    } else {
      setValue(undefined);
    }
  }, [options, props.value]);

  return (
    <Select
      isClearable
      styles={props.customStyles}
      menuPosition="fixed"
      ref={ref}
      options={options}
      value={value}
      onChange={handleChange}
      placeholder={""}
      noOptionsMessage={() => "Ne postoji"}
      isLoading={isLoading}
      {...{ error: props.error }}
    />
  );
});

export default CategorySelect;
